import { product } from '../../../schema';
import { denormalize } from 'normalizr';


export const getId = (_, props) => {
  const id = props.match.params.productId;
  return id ? parseInt(id, 10) : null;
};

export const selectHydrated = (state, id) => denormalize(id, product, state);


// WEBPACK FOOTER //
// ./src/redux/modules/products/selectors.js